// Path: ./src/app/pages/SignInPage/getFinalPermission.ts
import { GfRole } from "@swagger/typescript-fetch-goflyer";

export function getFinalPermission(rawRoles: GfRole) {
  const structurePermissions = rawRoles?.permissions?.map((value) => {
    const nameSplit = value.name.split("-");
    return {
      ...value,
      groupName: nameSplit[0],
      name: nameSplit[1],
    };
  });
  const filterPermission = structurePermissions?.filter(
    (value, index, self) =>
      index === self.findIndex((t) => t.groupName === value.groupName)
  );

  const finalPermission = filterPermission?.map((value) => {
    return {
      groupName: value.groupName,
      permissions: structurePermissions
        ?.filter((val) => val.groupName === value.groupName)
        ?.map((v) => {
          return { ...v, allowed: true };
        }),
    };
  });
  return finalPermission;
}
